import { useQuery } from "react-query";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { getRanking } from "../api/contest";
import * as Sentry from '@sentry/react';
import { useState } from "react";

const useRanking = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');
  const branch_id = searchParams.get('branch_id');
  const token = searchParams.get('token');
  const [isTimeout, setIsTimeout] = useState(false);

  const result = useQuery(["ranking", id, branch_id], async () => {
    if (token && branch_id) {
      const res = await getRanking({ branch_id, token });
      return res.data;
    }
    if (id && branch_id) {
      const res = await getRanking({ id, branch_id });
      return res.data;
    } else {
      Sentry.captureMessage(`Please enter valid url. [lack-token-or-branch-id] [token=${id}] [branch_id=${branch_id}]`);
      toast.warn("Please enter valid url.");
    }
    return null;
  }, {
    onError: (err: any) => {
      if (err.response?.status === 401) {
        setIsTimeout(true);
        return null
      }
      Sentry.captureException(err);
      toast.warn(err.message);
    },
    refetchInterval: 3*60*1000,
  });

  return { data: result.data, isTimeout };
}

export default useRanking;